import { useState } from "react";
import {
  FaChalkboardTeacher,
  FaArrowRight,
  FaTimes,
  FaArrowLeft,
} from "react-icons/fa";
import "./LecturersSection.css";

const lecturersData = Array.from({ length: 8 }, (_, i) => ({
  image: `/images/home/lecturers/${String(i + 1).padStart(2, "0")}.webp`,
}));

const LecturersSection = () => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const openLightbox = (index) => {
    setCurrentIndex(index);
    setLightboxOpen(true);
  };

  const closeLightbox = () => setLightboxOpen(false);

  const prevImage = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? lecturersData.length - 1 : prev - 1
    );
  };

  const nextImage = () => {
    setCurrentIndex((prev) =>
      prev === lecturersData.length - 1 ? 0 : prev + 1
    );
  };

  return (
    <section className="lecturers">
      <div className="lecturers__container">
        <div className="lecturers__icon">
          <FaChalkboardTeacher />
        </div>
        <h2 className="lecturers__title">GIẢNG VIÊN</h2>

        <div className="lecturers__cards">
          {lecturersData.map((lecturer, index) => (
            <div
              key={index}
              className="lecturer-card"
              onClick={() => openLightbox(index)}
            >
              <img
                src={lecturer.image}
                alt={`Lecturer ${index + 1}`}
                loading="lazy"
              />
            </div>
          ))}
        </div>

        <div className="lecturers__btn">
          <button className="lecturers__btn--primary">
            Xem thêm <FaArrowRight className="btn-icon" />
          </button>
        </div>

        {/* Lightbox */}
        {lightboxOpen && (
          <div className="lightbox">
            <div
              className="lightbox-overlay"
              onClick={closeLightbox}
            ></div>
            <div className="lightbox-content">
              <button
                className="lightbox-close"
                onClick={closeLightbox}
              >
                <FaTimes />
              </button>
              <button
                className="lightbox-prev"
                onClick={prevImage}
              >
                <FaArrowLeft />
              </button>
              <img
                src={lecturersData[currentIndex].image}
                alt={`Lecturer ${currentIndex + 1}`}
              />
              <button
                className="lightbox-next"
                onClick={nextImage}
              >
                <FaArrowRight />
              </button>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default LecturersSection;
